import {AutoDetectLocaleL10nProvider} from '../i18n/L10nProvider';
import {ComponentWithoutChildren} from '../react/types';
import {SimpleThemeProvider} from '../theme/ThemeProvider';
import {PublicOutlet} from './PublicOutlet';

export const PublicAppOutlet: ComponentWithoutChildren = () => {
  return (
    <AutoDetectLocaleL10nProvider>
      <SimpleThemeProvider>
        <PublicOutlet />
      </SimpleThemeProvider>
    </AutoDetectLocaleL10nProvider>
  );
};

export default PublicAppOutlet; // Default export required for react lazy
